import React from 'react'
import PropTypes from 'prop-types'
import Markdown from '../markdown'
import useMobileDetect from '../../hooks/useMobileDetect'

import { Title } from '../typography/Typography'
import { 
  Wrapper,
  ContentWrapper,
  TextStyles,
} from './hero-banner.styles'

const HeroBanner = ({
  backgroundImageMobile,
  backgroundImage,
  backgroundImagePosition,
  backgroundImagePositionMobile,
  ctaButton,
  // eslint-disable-next-line 
  displayOption, // currently unused. Let's leave the prop here for future reference.
  showOverlay,
  subtext,
  title,
  videos,
}) => {
  // We need to detect if we're trying to do background video image to 
  // a mobile device and suppress it since we don't show it anyway (via CSS)
  const currentDevice = useMobileDetect()
  let videosToPass = []
  if(currentDevice.isDesktop()) {
    videosToPass = videos
  }
  const renderTitle = title ? <Title as='h1' dangerouslySetInnerHTML={{__html: title}} /> : null
  const renderSubtitle = subtext ? <Markdown source={subtext} className='hero__subtitle' /> : null

  return (
    <Wrapper
      variant='full'  
      backgroundSize='cover'
      backgroundSizeMobile='cover'
      backgroundImage={backgroundImage}
      backgroundImageMobile={backgroundImageMobile}
      backgroundImagePosition={backgroundImagePosition}
      backgroundImagePositionMobile={backgroundImagePositionMobile}
      videos={videosToPass}
      showOverlay={showOverlay}
      resizeImage>
      <ContentWrapper>
        <TextStyles>
          {renderTitle}
          {renderSubtitle}
        </TextStyles>
        {ctaButton}
      </ContentWrapper>
    </Wrapper>
  )
}

const IMAGE_POSITION_PROPS = PropTypes.oneOf([
  "alignCenter",
  "alignTop",
  "alignBottom",
  "alignRight",
  "alignRightTop",
  "alignRightBottom",
  "alignLeft",
  "alignLeftTop",
  "alignLeftBottom"
])

HeroBanner.propTypes = {
  backgroundImage: PropTypes.string,
  backgroundImageMobile: PropTypes.string,
  backgroundImagePosition: IMAGE_POSITION_PROPS,
  backgroundImagePositionMobile: IMAGE_POSITION_PROPS,
  ctaButton: PropTypes.node,
  displayOption: PropTypes.oneOf([
      "short",
      "regular",
      "tall",
      "huge",
      "full"
  ]),
  showOverlay: PropTypes.bool,
  subtext: PropTypes.string,
  title: PropTypes.string,
  videos: PropTypes.arrayOf(PropTypes.shape({})), // TODO: create PropType for videos array.
};

HeroBanner.defaultProps = {
  backgroundImage: null,
  backgroundImageMobile: null,
  backgroundImagePosition: 'alignCenter',
  backgroundImagePositionMobile: 'alignCenter',
  ctaButton: null,
  displayOption: null,
  showOverlay: true,
  subtext: null,
  title: null,
  videos: [],
};

export default HeroBanner
